module.exports = __webpack_public_path__ + "img/close.e1216f89.svg";